var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTwitter(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 18 18",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#twitter_svg__clip0_1557:354)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18 3.42a7.373 7.373 0 01-2.121.58 3.698 3.698 0 001.624-2.042 7.397 7.397 0 01-2.345.896 3.687 3.687 0 00-2.696-1.167c-2.384 0-4.136 2.225-3.598 4.534a10.484 10.484 0 01-7.61-3.858 3.698 3.698 0 001.142 4.93 3.677 3.677 0 01-1.672-.461c-.04 1.71 1.185 3.311 2.962 3.667a3.701 3.701 0 01-1.668.063 3.696 3.696 0 003.45 2.565A7.425 7.425 0 010 14.656a10.454 10.454 0 005.661 1.659c6.857 0 10.73-5.791 10.496-10.985A7.519 7.519 0 0018 3.419z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "twitter_svg__clip0_1557:354"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h18v18H0z"
  })))));
}
export default SvgTwitter;